import React from 'react';
import { Textarea } from '../../../../components/ui/textarea';
import { AiButton, Field, StreamPreview, inputCls, wordCount } from '../shared';

const StepExpert = ({ wf, setData, runAi, ai }) => {
  const d = wf.data?.expert || {};
  const suggestions = d.ai?.suggestions || [];
  const selected = d.selected || [];
  const suggesting = ai.running && ai.action === 'expert_suggest';
  const applying = ai.running && ai.action === 'expert_apply';

  const suggest = async () => {
    const res = await runAi('expert_suggest');
    if (res) setData('expert', { ai: res, selected: [] });
  };
  const toggle = (i) => setData('expert', { selected: selected.includes(i) ? selected.filter((x) => x !== i) : [...selected, i] });
  const apply = async () => {
    const res = await runAi('expert_apply', { notes: d.notes || '', selected: selected.map((i) => suggestions[i]) });
    if (res) setData('expert', { applied_at: new Date().toISOString() });
  };

  return (
    <div className="space-y-6">
      <Field label="Expert notes from the BriefingIQ team" hint="Practitioner insight, contrarian takes, how BriefingIQ handles this in practice. Plain text is fine." testId="expert-notes-field">
        <Textarea value={d.notes || ''} onChange={(e) => setData('expert', { notes: e.target.value })} rows={6} className={inputCls} placeholder="e.g. Our customers see the biggest gains when intake is enforced before the executive calendar is touched…" data-testid="expert-notes-input" />
      </Field>
      <div className="flex items-center gap-3 flex-wrap">
        <AiButton onClick={suggest} running={suggesting} label="Suggest BriefingIQ angles with AI" runningLabel="Finding angles…" secondary testId="expert-suggest-btn" />
        <AiButton onClick={apply} running={applying} label="Weave into draft" runningLabel="Revising draft…" testId="expert-apply-btn" disabled={!d.notes?.trim() && selected.length === 0} />
        <span className="text-xs text-ink-3">Draft: {wordCount(wf.article?.content)} words{d.applied_at ? ' · expert inputs applied' : ''}</span>
      </div>
      {(suggesting || applying) && <StreamPreview text={ai.text} label={applying ? 'Revising the draft…' : 'Finding angles…'} />}
      {suggestions.length > 0 && !suggesting && (
        <div className="space-y-2" data-testid="expert-suggestions">
          <div className="text-[11px] uppercase tracking-wider text-ink-3">Tick the angles worth adding</div>
          {suggestions.map((s, i) => (
            <label key={i} className={`flex gap-3 p-4 rounded-2xl border cursor-pointer transition-colors ${selected.includes(i) ? 'border-ink bg-[var(--bg-alt)]' : 'border-[var(--line-2)] hover:border-ink'}`}>
              <input type="checkbox" checked={selected.includes(i)} onChange={() => toggle(i)} className="mt-1" data-testid={`expert-suggestion-${i}`} />
              <div className="min-w-0">
                <div className="text-sm font-medium text-ink">{s.angle}</div>
                <div className="text-[11px] text-ink-3 mt-0.5">Where: {s.where_to_add}</div>
                <div className="text-sm text-ink-2 mt-2 italic">“{s.snippet}”</div>
              </div>
            </label>
          ))}
        </div>
      )}
      <div className="text-xs text-ink-3">This step is optional — continue if the draft needs no expert additions.</div>
    </div>
  );
};

export default StepExpert;
